export type Serialized<T> = {
  [P in keyof T]: T[P] extends Date
    ? string
    : T[P] extends Date | null
      ? string | null
      : T[P] extends Date | undefined
        ? string | undefined
        : T[P] extends Date | null | undefined
          ? string | null | undefined
          : Serialized<T[P]>
}

export enum Timezones {
  // United States
  AMERICA_ADAK = 'America/Adak',
  AMERICA_ANCHORAGE = 'America/Anchorage',
  AMERICA_BOISE = 'America/Boise',
  AMERICA_CHICAGO = 'America/Chicago',
  AMERICA_DENVER = 'America/Denver',
  AMERICA_DETROIT = 'America/Detroit',
  AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
  AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
  AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
  AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
  AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
  AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
  AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
  AMERICA_INDIANA_WINAMAC = 'America/Indiana/Winamac',
  AMERICA_JUNEAU = 'America/Juneau',
  AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
  AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  AMERICA_MENOMINEE = 'America/Menominee',
  AMERICA_METLAKATLA = 'America/Metlakatla',
  AMERICA_NEW_YORK = 'America/New_York',
  AMERICA_NOME = 'America/Nome',
  AMERICA_NORTH_DAKOTA_BEULAH = 'America/North_Dakota/Beulah',
  AMERICA_NORTH_DAKOTA_CENTER = 'America/North_Dakota/Center',
  AMERICA_NORTH_DAKOTA_NEW_SALEM = 'America/North_Dakota/New_Salem',
  AMERICA_PHOENIX = 'America/Phoenix',
  AMERICA_SITKA = 'America/Sitka',
  AMERICA_YAKUTAT = 'America/Yakutat',
  US_ALASKA = 'US/Alaska',
  US_ARIZONA = 'US/Arizona',
  US_CENTRAL = 'US/Central',
  US_EASTERN = 'US/Eastern',
  US_HAWAII = 'US/Hawaii',
  US_MICHIGAN = 'US/Michigan',
  US_MOUNTAIN = 'US/Mountain',
  US_PACIFIC = 'US/Pacific',

  // Canada
  AMERICA_CAMBRIDGE_BAY = 'America/Cambridge_Bay',
  AMERICA_EDMONTON = 'America/Edmonton',
  AMERICA_HALIFAX = 'America/Halifax',
  AMERICA_IQALUIT = 'America/Iqaluit',
  AMERICA_MONCTON = 'America/Moncton',
  AMERICA_ST_JOHNS = 'America/St_Johns',
  AMERICA_TORONTO = 'America/Toronto',
  AMERICA_VANCOUVER = 'America/Vancouver',
  AMERICA_WHITEHORSE = 'America/Whitehorse',
  AMERICA_WINNIPEG = 'America/Winnipeg',
  AMERICA_YELLOWKNIFE = 'America/Yellowknife',
  CANADA_ATLANTIC = 'Canada/Atlantic',
  CANADA_CENTRAL = 'Canada/Central',
  CANADA_EASTERN = 'Canada/Eastern',
  CANADA_MOUNTAIN = 'Canada/Mountain',
  CANADA_NEWFOUNDLAND = 'Canada/Newfoundland',
  CANADA_PACIFIC = 'Canada/Pacific',
  CANADA_SASKATCHEWAN = 'Canada/Saskatchewan',
  CANADA_YUKON = 'Canada/Yukon',
}
